module.exports = __webpack_public_path__ + "assets/80cabdef8798838335a6386e95c2f25b.jpg";